import { AddCircle, PersonAdd } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { createContext, useEffect, useState } from 'react'
import { ModalAgregarDireccionComponent } from '../../components/direcciones/ModalAgregarDireccionComponent';
import { TablaDireccionesComponent } from '../../components/direcciones/TablaDireccionesComponent';
import { ModalAgregarUsuarioComponent } from '../../components/usuarios/ModalAgregarUsuarioComponent';
import { TablaUsuariosComponent } from '../../components/usuarios/TablaUsuariosComponent'
import { ObtenerDirecciones } from '../../helpers/DireccionesHelper';
import { ObtenerUsuarios } from '../../helpers/UsuariosHelper';


export const DireccionesContext = createContext();

export const DireccionesPage = () => {
    const [direccionSeleccionada, setDireccionSeleccionada] = useState();
    const [direcciones, setDirecciones] = useState([]);
    const [usuarios, setUsuarios] = useState([])
    const [modalAgregaDireccion, setModalAgregaDireccion] = useState(false);
    const [editandoDireccion, setEditandoDireccion] = useState(false);
    
    const obtenerDirecciones = async() => {
        const respuesta = await ObtenerDirecciones().then(datos=>setDirecciones(datos));
        console.log('datos obtenidos',respuesta);
    }

    useEffect(() => {
        console.log('direcciones', direcciones);
    }, [direcciones])
    
    const obtenerUsuarios = () => {
      ObtenerUsuarios().then(datos => {console.log('usuarios obtenidos en direccion page', datos);setUsuarios(datos)});
      
    }

    useEffect(() => {
      obtenerUsuarios();
    }, [])
    

  return (
    <DireccionesContext.Provider value={{direccionSeleccionada, setDireccionSeleccionada,
        modalAgregaDireccion, setModalAgregaDireccion, obtenerDirecciones, direcciones, setDirecciones, usuarios,
        setEditandoDireccion, editandoDireccion
    }}>
    <div
    style={{
        display:'flex',
        flexDirection:'column',
        flex:1,
          color:'black',
          marginTop:10,
          marginLeft:40,
          marginRight:20,
      }}    
    >
    <div
        style={{
          display:'flex',
          flexDirection:'row',
          justifyContent:'space-between',
          maxWidth:'55vw'
        }}
      >
        <span
            style={{
              fontSize:40,
              fontWeight:'bold'
            }}
            >
            Direcciones
        </span>
        <span
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center'
          }}
        >
          <IconButton
            onClick={() => {setModalAgregaDireccion(true)}}
          >
            <PersonAdd style={{color:'#60318A'}} color="#60318A" />
            Agregar
          </IconButton>
        </span>
      </div>
      <div>
          <TablaDireccionesComponent />
      </div>
      <ModalAgregarDireccionComponent  />
    </div>
    </DireccionesContext.Provider>
  )
}
